"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RemoveSavedIdModalState_1 = require("./RemoveSavedIdModalState");
/** Platform UI Components */
var Button_1 = require("@idp/ui-components/components/atoms/Button");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var Modal_1 = require("@idp/ui-components/components/atoms/Modal");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var Checkbox_1 = require("@idp/ui-components/components/atoms/Checkbox");
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { RemoveSavedIdModalCms } from './RemoveSavedIdModal.cms';
/** Stylesheets */
var styles = require("./RemoveSavedIdModal.scss");
var ReportingService_1 = require("../../../../../../api/ReportingService");
var ReportingService_2 = require("../../../../../../api/ReportingService");
var RemoveSavedIdModal = /** @class */ (function (_super) {
    __extends(RemoveSavedIdModal, _super);
    // private RemoveSavedIdModalCmsData: RemoveSavedIdModalCms;
    function RemoveSavedIdModal(props) {
        var _this = _super.call(this, props) || this;
        _this.reportingService = new ReportingService_1.default();
        _this.toDeleteIds = [];
        _this.checkBoxclicked = _this.checkBoxclicked.bind(_this);
        _this.state = new RemoveSavedIdModalState_1.default();
        _this.initializeEvents();
        return _this;
    }
    RemoveSavedIdModal.prototype.analyticsRemoveSavedIdsPageLoad = function () {
        console.log('analyticsRemoveSavedIdsPageLoad');
        this.reportingService.firePageLoadEvent(ReportingService_2.PageUrls.REMOVE_SAVED_ID_MODAL, ReportingService_2.PageName.REMOVE_SAVED_ID_MODAL);
    };
    RemoveSavedIdModal.prototype.componentDidMount = function () {
        this.analyticsRemoveSavedIdsPageLoad();
    };
    RemoveSavedIdModal.prototype.initializeEvents = function () {
        var _this = this;
        // this.RemoveSavedIdModalCmsData = CMS.get(new RemoveSavedIdModalCms(), 'RemoveSavedIdModal').content;
        this.RemoveSavedIdModalCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        this.removeSavedIDModalBtnContinueEvent = {
            onClick: function () {
                _this.fireContinueEvent();
                _this.removeSavedIDModalContinue();
            },
        };
        this.removeSavedIDModalBtnCloseEvent = {
            onClick: function () {
                _this.fireCancelEvent();
                _this.clearDeleteIds();
                _this.props.events.onCancel();
            },
        };
        this.removeSavedIDModalCloseEvent = {
            onClose: function () {
                _this.fireCancelEvent();
                _this.clearDeleteIds();
                _this.props.events.onCancel();
            },
        };
    };
    RemoveSavedIdModal.prototype.fireCancelEvent = function () {
        this.reportingService.fireLinkClickEvent('Cancel', ReportingService_2.PageUrls.LOGIN_PAGE);
    };
    RemoveSavedIdModal.prototype.fireContinueEvent = function () {
        this.reportingService.fireLinkClickEvent('Continue', ReportingService_2.PageUrls.REMOVE_SAVED_ID_ARE_YOU_SURE_MODAL);
    };
    RemoveSavedIdModal.prototype.removeSavedIDModalContinue = function () {
        this.props.events.onContinue(this.toDeleteIds);
        this.clearDeleteIds();
    };
    RemoveSavedIdModal.prototype.checkBoxclicked = function (id, checked) {
        console.log("checkBoxclicked " + id, checked);
        if (checked) {
            this.toDeleteIds.push(id);
        }
        else {
            var index = this.toDeleteIds.indexOf(id, 0);
            if (index > -1) {
                this.toDeleteIds.splice(index, 1);
            }
        }
        this.setState({
            disableContinue: this.toDeleteIds.length === 0,
        });
    };
    // Reset the state for if it reopens
    RemoveSavedIdModal.prototype.clearDeleteIds = function () {
        this.toDeleteIds = [];
        this.setState({
            disableContinue: true,
        });
    };
    RemoveSavedIdModal.prototype.render = function () {
        var _this = this;
        var idCheckboxes = this.props.data.savedIds.map(function (id, index) {
            var onCheckboxChange = function (isChecked) {
                _this.checkBoxclicked(id, isChecked.payload);
            };
            var checked = _this.toDeleteIds.indexOf(id) !== -1;
            return (React.createElement(Checkbox_1.default, { key: id, data: {
                    text: id,
                    value: checked,
                }, events: { onCheckboxChange: onCheckboxChange }, testId: "Removed_Saved_ID_" + index }));
        });
        return (React.createElement(Modal_1.default, { accessibilityText: this.RemoveSavedIdModalCmsData.loginWidget.removeModalTitle + 'Modal', options: {
                center: true,
                show: this.props.data.show,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
            }, events: this.removeSavedIDModalCloseEvent, testId: 'Removed_Saved_ID_Modal' },
            React.createElement("div", { className: [styles.loginRemoveSavedidModalWrapper].join(' ') },
                React.createElement("div", { className: [styles.modalHeader].join(' ') },
                    React.createElement("h1", null, this.RemoveSavedIdModalCmsData.loginWidget.removeModalTitle)),
                React.createElement("div", { className: [styles.modalContent].join(' ') },
                    React.createElement("p", null, this.RemoveSavedIdModalCmsData.loginWidget.removeModalContent),
                    React.createElement("div", { className: [styles.customCheckbox].join(' ') }, idCheckboxes)),
                React.createElement("div", { className: [styles.modalFooter].join(' ') },
                    React.createElement("div", { className: [styles.ctaButtonGroup].join(' ') },
                        React.createElement(Button_1.default, { data: {
                                disabled: this.state.disableContinue,
                                text: this.RemoveSavedIdModalCmsData.loginWidget.removeModalButtonPrimaryCTA,
                            }, events: this.removeSavedIDModalBtnContinueEvent, options: {
                                size: ButtonProps_1.ButtonSize.LARGE,
                            }, testId: 'Remove_Saved_Id_Modal_Button_Continue' }),
                        React.createElement(Button_1.default, { data: {
                                text: this.RemoveSavedIdModalCmsData.loginWidget.removeModalButtonSecondaryCTA,
                            }, events: this.removeSavedIDModalBtnCloseEvent, options: {
                                size: ButtonProps_1.ButtonSize.LARGE,
                                type: ButtonProps_1.ButtonType.GHOST,
                            }, testId: 'Remove_Saved_Id_Modal_Button_Cancel' }))))));
    };
    return RemoveSavedIdModal;
}(React.Component));
exports.default = RemoveSavedIdModal;
//# sourceMappingURL=RemoveSavedIdModal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/RemoveSavedIDModal/RemoveSavedIdModal.js
// module id = 1507
// module chunks = 8